import { createSlice } from '@reduxjs/toolkit';
import { IQueryParams } from '../../../models/common/IQueryParams';
import { defaultSourceListStatus } from '../../../utilities/sources/SourceRegistryUtil';

/**
 * Interface for Source Registry Filter state in Redux store
 */
export interface ISourceRegistryFilterState extends IQueryParams {
  sort: string;
  sortType: string;
}

const initialState: ISourceRegistryFilterState = {
  searchText: '',
  status: defaultSourceListStatus,
  fromDate: null,
  toDate: null,
  sort: 'updatedTimestamp',
  sortType: 'DESC'
};

const filterSourceRegistrySlice = createSlice({
  name: 'filterSourceRegistry',
  initialState,
  reducers: {
    addFilterSourceRegistryData: (state, action) => {
      state.searchText = action.payload.searchText;
      state.status = action.payload.status;
      state.fromDate = action.payload.fromDate;
      state.toDate = action.payload.toDate;
    },
    addSortSourceRegistryData: (state, action) => {
      state.sort = action.payload.sort;
      state.sortType = action.payload.sortType;
    },
    clearFilterSourceRegistry: (state) => {
      state.searchText = '';
      state.status = '';
      state.fromDate = null;
      state.toDate = null;
      state.sort = '';
      state.sortType = '';
    },
    clearQueryParamSourceRegistry: (state) => {
      state.searchText = '';
      state.status = '';
      state.fromDate = null;
      state.toDate = null;
      state.sort = '';
      state.sortType = '';
    }
  }
});

export const {
  addFilterSourceRegistryData,
  addSortSourceRegistryData,
  clearFilterSourceRegistry,
  clearQueryParamSourceRegistry
} = filterSourceRegistrySlice.actions;

export default filterSourceRegistrySlice.reducer;
